export default {
    Loading(state) {
        return state.Loading;
    },

    MenuActive(state) {
        return state.MenuActive
    },

    IsTokenExpired(state) {
        return state.IsTokenExpired;
    },

    IsExpandSibar(state) {
        return state.IsExpandSibar;
    }
}